<template>
  <div>
    <table class="table table-striped table-bordered invoice-table table-responsive-md table-responsive-sm">
      <thead>
      <tr>
      </tr>
      </thead>
      <tbody>
      <template v-for="(group, category) in sortedGroupedFeatures" :key="category">
        <!-- Category Row -->
        <tr>
          <td colspan="2" class="category-row">
            <strong>{{ category }}</strong>
          </td>
        </tr>

        <!-- Features of the category -->
        <tr v-for="feature in group" :key="feature.id">
          <th scope="row">{{ productFeatureName(product, feature.id) }}</th>
          <td>
            <template v-if="feature.feature_attribute_id != null">

              <template v-if="Array.isArray(productFeatureValue(product, feature.id))">

                {{ specialInputValue(product, feature) }}

                <!--                <span class="mx-2" v-for="(item,index) in productFeatureValue(product, feature.id)">
                                  {{ item.feature_attribute.value }} {{index}}
                                </span>-->
              </template>

              <template v-else>
                <template v-if="activeFeatureLinks">
                  <m-a
                      :href="{name: 'Products', query: {features: feature.feature_attribute_id}}">
                    {{ productFeatureValue(product, feature.id) }}
                  </m-a>
                </template>
                <template v-else>
                  {{ productFeatureValue(product, feature.id) }}
                </template>
              </template>


            </template>

            <template v-else>
              {{ productFeatureValue(product, feature.id) }}
            </template>
          </td>
        </tr>
      </template>
      </tbody>
    </table>
  </div>
</template>

<script>
import {defineComponent} from 'vue'
import product, {
  productFeatureName,
  productFeatureValue,
  productTableFeature
} from "@moeinmdn/mixitweb-front-modules/src/plugin/Modules/Product";
import mA from '../../../Tags/A.vue'

export default defineComponent({
  name: "SingleProductTableFeature1",
  components: {mA},
  props: {
    product: {
      default: {}
    },
    activeFeatureLinks: {
      default: true,
      type: Boolean
    }
  },
  data() {
    return {
      groupedFeatures: []
    };
  },
  computed: {
    sortedGroupedFeatures() {
      // Sort the groups by the 'category_order' inside feature.extra
      const sortedCategories = Object.entries(this.groupedFeatures).sort((a, b) => {
        const orderA = a[1][0]?.extra?.category_order || 0; // Default order is 0 if no order is found
        const orderB = b[1][0]?.extra?.category_order || 0; // Default order is 0 if no order is found
        return orderB - orderA; // Higher order comes first
      });

      // Now sort each group of features by 'item_order' inside feature.extra
      const sortedGroups = sortedCategories.map(([category, features]) => {
        const sortedFeatures = features.sort((a, b) => {
          const itemOrderA = a.extra?.item_order || 0; // Default order is 0 if no item_order is found
          const itemOrderB = b.extra?.item_order || 0; // Default order is 0 if no item_order is found
          return itemOrderB - itemOrderA; // Lower item_order comes first
        });
        return [category, sortedFeatures]; // Return sorted group
      });

      // Convert back to object after sorting
      return Object.fromEntries(sortedGroups);
    }
  },
  methods: {
    productFeatureName,
    productFeatureValue,
    productTableFeature,
    groupByType(features) {
      let checkListGroups = []
      let removedItem = []
      let result = {}

      Object.entries(features).forEach(item => {
        let group = item[0]
        let items = item[1]
        result[group] = []

        items.forEach(feature => {
          let checkboxGroupName = feature.extra.group


          if ((['checkbox'].indexOf(feature.feature.type) > -1 && checkListGroups.indexOf(checkboxGroupName) == -1) || ['checkbox'].indexOf(feature.feature.type) == -1) {
            result[group].push(feature)
          }

          checkListGroups.push(checkboxGroupName)

        })

      })

      return result
    },
    groupFeaturesMethod() {
      const grouped = {};

      // Group features by their category
      this.productTableFeature(this.product).forEach((feature) => {
        const category = feature.extra && feature.extra.category ? feature.extra.category : 'Uncategorized';

        if (!grouped[category]) {
          grouped[category] = [];
        }

        grouped[category].push(feature);
      });

      return this.groupByType(grouped);
    },
    specialInputValue(product, feature) {
      let items = this.productFeatureValue(product, feature.id)
      let result = []

      items.forEach(item => {
        result.push(item.feature_attribute.value)
      })


      return result.join(', ')
    }
  },
  mounted() {
    this.groupedFeatures = this.groupFeaturesMethod()
  },
  watch: {
    product: {
      handler(oldValue, newValue) {
        this.groupedFeatures = this.groupFeaturesMethod()
      },
      deep: true
    }
  }
})
</script>

<style scoped>
/* Add any scoped styles here */
.category-row {
  background-color: #f8f9fa;
  font-weight: bold;
  text-align: center;
  font-size: 1.2em;
  padding: 10px;
}
</style>
